import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';

import { FieldWrapper } from './css';
import { thirdPartyUrls } from '../../utils/constant';

const FieldComplexLeadButton = ({ data }) => {
  const { name, label } = data;
  const handleRedirection = () => {
    window.open(thirdPartyUrls.complexLeadUrl, '_blank');
    window.focus();
  };
  return (
    <FieldWrapper>
      <Button
        type="button"
        name={name}
        variant={{ priority: 'high' }}
        onClick={() => handleRedirection()}
      >
        {label}
      </Button>
    </FieldWrapper>
  );
};

FieldComplexLeadButton.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string
  }).isRequired
};

export default FieldComplexLeadButton;
